import { chakra, HTMLChakraProps } from '@chakra-ui/react'
import React from 'react'

/**
 * White outline with a black band inside it. Banners sit on gradients that
 * run from dark purple to light aqua, and one of the two colors keeps 3:1
 * against any point of them.
 */
const bannerFocusRing = {
  outline: '2px solid',
  outlineColor: 'brand.contrast',
  outlineOffset: '2px',
  boxShadow: '0 0 0 2px {colors.black}',
}

type BannerControlProps = Omit<HTMLChakraProps<'button'>, 'type'>

export const BannerIconButton = React.forwardRef<
  HTMLButtonElement,
  BannerControlProps & { 'aria-label': string }
>((props, ref) => (
  <chakra.button
    ref={ref}
    type="button"
    display="flex"
    alignItems="center"
    justifyContent="center"
    flexShrink={0}
    cursor="pointer"
    borderRadius="sm"
    _focusVisible={bannerFocusRing}
    {...props}
  />
))
BannerIconButton.displayName = 'BannerIconButton'

export const BannerTextButton = React.forwardRef<
  HTMLButtonElement,
  BannerControlProps
>((props, ref) => (
  <chakra.button
    ref={ref}
    type="button"
    display="inline"
    cursor="pointer"
    borderRadius="sm"
    _focusVisible={bannerFocusRing}
    {...props}
  />
))
BannerTextButton.displayName = 'BannerTextButton'
